import styled, { keyframes } from 'styled-components';
import mediaImage from '../images/media.png';

// Unused legacy hero components removed

export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 105px;
  position: relative;
  z-index: 1;

  @media (max-width: 1024px) {
    padding: 0 32px;
  }

  @media (max-width: 768px) {
    padding: 0 24px;
  }

  @media (max-width: 480px) {
    padding: 0 20px;
  }
`;

// Legacy hero content removed

export const Highlight = styled.span`
  color: rgb(235, 184, 0);
`;

export const HighlightOrange = styled.span`
  color: rgb(235, 98, 0);
`;

export const HighlightVision = styled.span`
  color: rgb(245, 124, 10);
`;

export const HighlightCost = styled.span`
  color: rgb(235, 98, 0);
`;

export const HeroButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 40px;

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const PrimaryButton = styled.a`
  background-color: rgb(245, 124, 10);
  color: black;
  padding: 12px 24px;
  border-radius: 8px;
  text-decoration: none;
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 24px;
  font-weight: normal;
  transition: all 0.3s ease;
  border: 3px solid rgb(235, 98, 0);
  cursor: pointer;
  white-space: nowrap;
  opacity: 1;
  display: inline-block;

  &:hover {
    transform: translateY(-1px);
    background-color: rgb(255, 134, 20);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ProblemSection = styled.section`
  padding: 120px 0 200px;
  background: #21004d;
  position: relative;

  @media (max-width: 768px) {
    padding: 60px 0 60px;
  }
  @media (max-width: 480px) {
    padding: 40px 0 40px;
  }
`;

export const ProblemContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 105px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: start;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 60px;
    padding: 0 32px;
  }

  @media (max-width: 480px) {
    padding: 0 20px;
  }
`;

export const ProblemHeader = styled.div`
  text-align: left;
  position: sticky;
  top: 120px;
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;
  align-self: flex-start;
  
  &.animate {
    opacity: 1 !important;
    transform: translateY(0) !important;
  }

  h2 {
    font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
    font-size: 60px;
    font-weight: normal;
    margin-top: 24px;
    line-height: 1.3;

    @media (max-width: 768px) {
      font-size: 40px;
    }

    @media (max-width: 480px) {
      font-size: 32px;
    }
  }

  @media (max-width: 1024px) {
    position: static;
  }
`;

export const Badge = styled.div`
  display: inline-block;
  background-color: rgb(245, 124, 10);
  color: black;
  padding: 6px 18px;
  border-radius: 30px;
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 24px;
  font-weight: normal;
  margin-bottom: 20px;
  border: 3px solid rgb(235, 98, 0);
`;

export const ProblemGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
  padding-top: 40px;
`;

export const ProblemItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;
  
  &.animate {
    opacity: 1;
    transform: translateY(0);
  }

  .problem-image {
    width: 100%;
    height: 380px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
      object-fit: contain;
    }
  }

  .problem-content {
    h3 {
      font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
      font-size: 38px;
      font-weight: normal;
      margin-bottom: 16px;
      color: white;
      line-height: 1.3;
    }

    p {
      font-family: "Pretendard Regular", "Pretendard Regular Placeholder", sans-serif;
      font-size: 20px;
      color: rgba(255, 255, 255, 0.8);
      line-height: 1.6;
    }
  }
`;

export const SolutionSection = styled.section`
  padding: 120px 0;
  background: #2a0061;
  text-align: center;

  @media (max-width: 768px) {
    padding: 40px 0 60px;
  }
`;

export const SolutionHeader = styled.div`
  text-align: center;
  margin-bottom: 80px;
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;
  
  &.animate {
    opacity: 1 !important;
    transform: translateY(0) !important;
  }

  h2 {
    font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
    font-size: 60px;
    font-weight: normal;
    margin-top: 24px;
    line-height: 1.3;

    @media (max-width: 768px) {
      font-size: 40px;
    }
  }
`;

export const YellowBadge = styled.div`
  display: inline-block;
  background-color: rgb(235, 184, 0);
  color: black;
  padding: 6px 18px;
  border-radius: 30px;
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 24px;
  font-weight: normal;
  margin-bottom: 20px;
  border: 3px solid rgb(235, 98, 0);
`;

export const SolutionContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;
  gap: 24px;
  margin-top: 80px;
  width: 100%;
  padding: 0;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    gap: 40px;
    margin-top: 40px;
  }
  
  @media (max-width: 480px) {
    gap: 30px;
  }
`;

export const SolutionItem = styled.div`
  overflow: hidden;
  transition: all 0.3s ease;
  opacity: 0;

  &:nth-child(1) {
    grid-column: 2;
    grid-row: 1;
  }

  &:nth-child(2) {
    grid-column: 1;
    grid-row: 1 / 3;
  }

  &:nth-child(3) {
    grid-column: 2;
    grid-row: 2;
  }

  @media (max-width: 1024px) {
    &:nth-child(1), &:nth-child(2), &:nth-child(3) {
      grid-column: auto;
      grid-row: auto;
    }
  }

  &:hover {
    transform: translateY(-5px);
  }

  .item-image {
    width: 100%;
    height: 280px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
      object-fit: contain;
      transition: transform 0.3s ease;
    }
  }

  &:nth-child(2) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    
    .item-image {
      flex-grow: 1;
    }
    
    .item-content {
      margin-top: auto;
    }
  }

  .item-content {
    padding: 32px;
    text-align: left;
    
    @media (max-width: 768px) {
      padding: 0 0 20px 0;
    }
  }

  h3 {
    font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
    font-size: 38px;
    font-weight: normal;
    margin-bottom: 16px;
    color: white;
    line-height: 1.3;

    @media (max-width: 768px) {
      font-size: 28px;
      margin-bottom: 12px;
    }
  }

  p {
    font-family: "Pretendard Regular", "Pretendard Regular Placeholder", sans-serif;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.6;
    font-size: 20px;

    @media (max-width: 768px) {
      font-size: 16px;
    }
  }
`;

export const Solution2Section = styled.section`
  padding: 120px 0;
  background: #21004d;
  text-align: center;

  @media (max-width: 768px) {
    padding: 40px 0 60px;
  }
`;

export const Solution2Header = styled.div`
  text-align: center;
  margin-bottom: 80px;

  @media (max-width: 768px) {
    margin-bottom: 40px;
  }
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;
  
  &.animate {
    opacity: 1 !important;
    transform: translateY(0) !important;
  }

  h2 {
    font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
    font-size: 60px;
    font-weight: normal;
    margin-top: 24px;
    line-height: 1.3;

    @media (max-width: 768px) {
      font-size: 40px;
    }
  }
`;

export const Solution2Content = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  margin-top: 80px;
  width: 100%;
  padding: 0;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 40px;
    margin-top: 60px;
  }
`;

export const Solution2Item = styled.div`
  border-radius: 24px;
  overflow: hidden;
  transition: all 0.3s ease;
  opacity: 0;

  &:hover {
    transform: translateY(-5px);
  }

  .item-image {
    width: 100%;
    height: 280px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
      object-fit: contain;
      transition: transform 0.3s ease;
    }
  }

  .item-content {
    padding: 32px;
    text-align: left;
  }

  h3 {
    font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
    font-size: 38px;
    font-weight: normal;
    margin-bottom: 16px;
    color: white;
    line-height: 1.3;
  }

  p {
    font-family: "Pretendard Regular", "Pretendard Regular Placeholder", sans-serif;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.6;
    font-size: 20px;
  }
`;

export const Solution3Section = styled.section`
  padding: 120px 0;
  background: #2a0061;
  text-align: center;

  @media (max-width: 768px) {
    padding: 40px 0 60px;
  }
`;

export const Solution3Header = styled.div`
  text-align: center;
  margin-bottom: 80px;

  @media (max-width: 768px) {
    margin-bottom: 40px;
  }
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;
  
  &.animate {
    opacity: 1 !important;
    transform: translateY(0) !important;
  }

  h2 {
    font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
    font-size: 60px;
    font-weight: normal;
    margin-top: 24px;
    line-height: 1.3;

    @media (max-width: 768px) {
      font-size: 40px;
    }
  }
`;

export const Solution3Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
  margin-top: 80px;
  width: 100%;
  padding: 0;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 60px;
    margin-top: 60px;
  }
`;

export const Solution3Left = styled.div`
  opacity: 0;

  .solution3-image {
    width: 100%;
    height: 328px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
      object-fit: contain;
      transition: transform 0.3s ease;
    }
  }


`;

export const Solution3Right = styled.div`
  text-align: left;
  padding-left: 40px;
  opacity: 0;

  @media (max-width: 1024px) {
    padding-left: 0;
    text-align: center;
  }

  h3 {
    font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
    font-size: 38px;
    font-weight: normal;
    margin-bottom: 30px;
    color: white;
    line-height: 1.4;
  }

  p {
    font-family: "Pretendard Regular", "Pretendard Regular Placeholder", sans-serif;
    font-size: 20px;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.8;
  }
`;

export const BenefitsSection = styled.section`
  padding: 120px 0;
  background: #3c008a;

  @media (max-width: 768px) {
    padding: 40px 0 60px;
  }
`;

export const BenefitsHeader = styled.div`
  text-align: left;
  margin-bottom: 80px;

  @media (max-width: 768px) {
    margin-bottom: 40px;
  }
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;
  
  &.animate {
    opacity: 1 !important;
    transform: translateY(0) !important;
  }

  h2 {
    font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
    font-size: 60px;
    font-weight: normal;
    line-height: 1.3;
    color: white;

    @media (max-width: 768px) {
      font-size: 40px;
    }
  }
`;

export const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 80px;
  margin-top: 80px;
  width: 100%;
  padding: 0;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 60px;
    margin-top: 60px;
  }
`;

export const BenefitItem = styled.div`
  text-align: left;
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateY(30px);

  &.animate {
    opacity: 1;
    transform: translateY(0);
    transition: all 0.8s ease;
  }

  &:hover {
    transform: translateY(-5px);
  }

  .benefit-number {
    font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
    font-size: 96px;
    font-weight: normal;
    color: rgb(235, 98, 0);
    margin-bottom: 20px;
    display: block;
    line-height: 1;

    @media (max-width: 768px) {
      font-size: 64px;
      margin-bottom: 15px;
    }
  }

  .benefit-description {
    font-family: "Pretendard Regular", "Pretendard Regular Placeholder", sans-serif;
    font-size: 20px;
    color: white;
    line-height: 1.5;

    @media (max-width: 768px) {
      font-size: 18px;
    }
  }
`;

export const CertificationSection = styled.section`
  padding: 120px 0;
  background: #21004d;

  @media (max-width: 768px) {
    padding: 40px 0 60px;
  }
`;

export const CertificationHeader = styled.div`
  text-align: center;
  margin-bottom: 80px;

  @media (max-width: 768px) {
    margin-bottom: 40px;
  }
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;
  
  &.animate {
    opacity: 1 !important;
    transform: translateY(0) !important;
  }

  h2 {
    font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
    font-size: 60px;
    font-weight: normal;
    line-height: 1.3;
    color: white;

    @media (max-width: 768px) {
      font-size: 40px;
    }
  }
`;

export const CertificationCarouselWrapper = styled.div`
  overflow: hidden;
  margin-top: 60px;
  position: relative;
  max-width: 1320px;
  margin-left: auto;
  margin-right: auto;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100px;
    z-index: 2;
    pointer-events: none;
  }

  &::before {
    left: 0;
    background: linear-gradient(to right, #21004D, transparent);
  }

  &::after {
    right: 0;
    background: linear-gradient(to left, #21004D, transparent);
  }

  @media (max-width: 1400px) {
    max-width: 990px;
  }

  @media (max-width: 1024px) {
    max-width: 660px;
  }

  @media (max-width: 768px) {
    max-width: 330px;
  }
`;

export const CertificationCarousel = styled.div`
  .certification-track {
    display: flex;
    gap: 30px;
    animation: scroll 30s linear infinite;
    width: fit-content;

    .certification-item {
      flex-shrink: 0;
      width: 300px;
      height: 400px;
      border-radius: 15px;
      overflow: hidden;
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  @keyframes scroll {
    0% { 
      transform: translateX(0); 
    }
    100% { 
      transform: translateX(calc(-300px * 4 - 30px * 3)); 
    }
  }
`;

export const PromotionSection = styled.section`
  padding: 120px 0;
  background: #21004d;

  @media (max-width: 768px) {
    padding: 40px 0 60px;
  }
`;

export const PromotionContent = styled.div`
  background: #3c008a;
  border-radius: 24px;
  padding: 80px 60px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: start;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 60px;
    text-align: center;
    padding: 60px 40px;
    align-items: center;
  }

  @media (max-width: 768px) {
    padding: 40px 30px;
  }

  @media (max-width: 480px) {
    padding: 40px 20px;
    gap: 40px;
  }
`;

export const PromotionLeft = styled.div`
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;
  
  &.animate {
    opacity: 1 !important;
    transform: translateY(0) !important;
  }

  h2 {
    font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
    font-size: 60px;
    font-weight: normal;
    line-height: 1.3;
    color: white;
    margin-bottom: 0;

    @media (max-width: 768px) {
      font-size: 40px;
    }
  }
`;

export const PromotionRight = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;
  
  &.animate {
    opacity: 1 !important;
    transform: translateY(0) !important;
  }

  .promotion-banner {
    max-width: 100%;
    
    .sale-image {
      width: auto;
      height: 523px;

      @media (max-width: 768px) {
        height: 400px;
      }

      @media (max-width: 480px) {
        height: 250px;
        width: 100%;
        object-fit: contain;
      }
    }
  }
`;

export const MediaSection = styled.section`
  padding: 120px 0;
  background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${mediaImage});
  background-size: cover;
  background-position: center;
  background-attachment: scroll;
  color: white;
  text-align: center;
  position: relative;

  @media (max-width: 768px) {
    padding: 40px 0 60px;
  }
`;

export const MediaContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
`;

export const MediaText = styled.div`
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;
  
  &.animate {
    opacity: 1 !important;
    transform: translateY(0) !important;
  }

  h2 {
    font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
    font-size: 60px;
    font-weight: normal;
    margin-bottom: 20px;
    line-height: 1.3;
    color: white;

    @media (max-width: 768px) {
      font-size: 40px;
    }
  }

  .media-subtitle {
    font-family: "Pretendard Regular", "Pretendard Regular Placeholder", sans-serif;
    font-size: 24px;
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 30px;

    @media (max-width: 768px) {
      font-size: 20px;
    }
  }
`;

export const FinalCTASection = styled.section`
  padding: 120px 0;
  background: #21004d;

  @media (max-width: 768px) {
    padding: 40px 0 60px;
  }
`;

export const FinalCTAContent = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 80px;
  align-items: start;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 80px;
    text-align: center;
    align-items: center;
  }
`;

export const FinalCTALeft = styled.div`
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;
  
  &.animate {
    opacity: 1 !important;
    transform: translateY(0) !important;
  }

  h2 {
    font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
    font-size: 60px;
    font-weight: normal;
    margin-bottom: 20px;
    line-height: 1.3;
    color: white;

    @media (max-width: 768px) {
      font-size: 40px;
    }
  }

  p {
    font-family: "Pretendard Regular", "Pretendard Regular Placeholder", sans-serif;
    font-size: 20px;
    color: white;
    line-height: 1.6;
    margin-top: 20px;

    @media (max-width: 768px) {
      font-size: 18px;
    }
  }
`;

export const FinalCTARight = styled.div`
  .simple-contact-form {
    display: flex;
    flex-direction: column;
    gap: 20px;

    .form-field {
      display: flex;
      flex-direction: column;
      gap: 8px;

      &.full-width {
        width: 100%;
      }

      label {
        font-family: "Pretendard Regular", "Pretendard Regular Placeholder", sans-serif;
        color: white;
        font-weight: 500;
        font-size: 16px;
        margin-bottom: 4px;

        @media (max-width: 768px) {
          font-size: 14px;
        }
      }

      input, textarea {
        width: 100%;
        padding: 14px 16px;
        border: none;
        border-radius: 10px;
        background: rgba(255, 255, 255, 0.9);
        color: #333;
        font-size: 16px;
        transition: all 0.3s ease;
        box-sizing: border-box;
        font-family: inherit;

        &::placeholder {
          color: rgba(0, 0, 0, 0.5);
        }

        &:focus {
          outline: none;
          background: white;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
      }

      textarea {
        resize: vertical;
        min-height: 120px;
      }
    }

    .submit-btn {
      padding: 18px 32px;
      background: rgb(245, 124, 10);
      color: white;
      border: none;
      border-radius: 10px;
      font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
      font-size: 20px;
      font-weight: normal;
      cursor: pointer;
      transition: all 0.3s ease;
      margin-top: 10px;

      &:hover {
        transform: translateY(-2px);
        background: rgb(255, 134, 20);
        box-shadow: 0 8px 25px rgba(245, 124, 10, 0.3);
      }

      &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
        transform: none;
      }

      @media (max-width: 768px) {
        font-size: 18px;
        padding: 16px 28px;
      }
    }
  }
`;

// 새로운 Hero 섹션을 위한 styled 컴포넌트들
export const NewHeroSection = styled.section`
  height: 100vh;
  max-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  text-align: center;
  position: relative;
  overflow: hidden;
  padding-top: 15vh;
`;

export const HeroImageGrid = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
`;

export const HeroImageItem = styled.div`
  position: absolute;
  overflow: hidden;
  transition: all 0.3s ease;
  border-radius: 8px;

  &:nth-child(1) {
    top: 0%;
    left: 0%;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    &:nth-child(1) {
      top: 0%;
      left: 0%;
      width: 100%;
      height: 100%;
    }
  }

  @media (max-width: 480px) {
    &:nth-child(1) {
      top: 0%;
      left: 0%;
      width: 100%;
      height: 100%;
    }
  }
`;



export const NewHeroContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 2;

  h1 {
    font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
    font-size: 92px;
    font-weight: normal;
    margin-bottom: 32px;
    line-height: 1.2;
    color: white;

    @media (max-width: 768px) {
      font-size: 52px;
    }

    @media (max-width: 480px) {
      font-size: 36px;
      margin-bottom: 24px;
    }
  }

  p {
    font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
    font-size: 32px;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 40px;
    line-height: 1.6;

    @media (max-width: 768px) {
      font-size: 20px;
    }

    @media (max-width: 480px) {
      font-size: 18px;
    }
  }
`;

// keyframes를 먼저 정의
const complexRouteKeyframes = keyframes`
  /* 0% - 30%: 오른쪽에서 90% 지점으로 이동 */
  0% {
    transform: translateX(calc(100vw + 150px));
  }
  30% {
    transform: translateX(calc(90vw - 240px));
  }
  
  /* 30% - 50%: 90% 지점에서 정차 */
  50% {
    transform: translateX(calc(90vw - 240px));
  }
  
  /* 50% - 100%: 90%에서 왼쪽 끝으로 이동 */
  100% {
    transform: translateX(-150px);
  }
`;

// 도로 위에서 좌우로 움직이는 애니메이션을 위한 컴포넌트들
export const RoadAnimationContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 300px;
  z-index: 1;
  overflow: hidden;
`;
// Unused Road component removed

export const MovingVehicle = styled.div`
  position: absolute;
  bottom: 120px;
  width: 240px;
  height: 160px;
  z-index: 10;
  animation: ${complexRouteKeyframes} 30s linear infinite;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  
  @media (max-width: 768px) {
    width: 200px;
    height: 140px;
  }
  
  @media (max-width: 480px) {
    width: 160px;
    height: 120px;
  }
`;